import * as authEvents from "../../store/events/auth";
import * as profileEvents from "../../store/events/profile";
import ErrorLoading from "../ErrorMessages/ErrorLoading";
import React from "react";
import { connect } from "react-redux";

const ProfileUnavailable = props => {

	const {
		endSession,
		getProfile
	} = props;

	return (
		<div className="cmp-loading--profile-unavailable">
			<ErrorLoading
				alertDescription="Your user profile is currently unavailable. We apologize for the inconvenience."
				alertTitle="Oops..."
				primaryActionCallback={() => {
					getProfile(true);
				}}
				primaryActionLabel="Retry"
				secondaryActionCallback={() => { endSession(); }}
				secondaryActionLabel="Sign Out"
			/>
		</div>
	);
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
	endSession: data => dispatch(authEvents.endSession(data)),
	getProfile: getInboxOnSuccess => dispatch(profileEvents.getProfile(getInboxOnSuccess))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileUnavailable);